<template>
    <div class="modal fade" :class="{ in: isShowModal, active: isShow}" id="selectRoomModal"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img class="common-modal-close" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div>

                <div class="modal-body">
                    <div class="container" style="width:100%;">
                        <div class="row">
                            <div class="col-sm-8 col-lg-8">
                                <div class="selectRoom__diagram_pic" style="height: 799.533px;">
                                    <div class="selectRoom__diagram_picture ">
                                        <img :src="deckImage" width="100%">
                                    </div>
                                    <div class="selectRoom__diagram_arrowPic">
                                        <img src="https://resource.rcclchina.com.cn/cruiseDetail/pc/diagramImg-arrowBg.png" width="100%">
                                        <div class="selectRoom__arrowPic__txt">
                                            <p>上下滑动</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="col-sm-4 col-lg-4">
                                <p>选择甲板</p>
                                <div class="selectRoom__diagram_floor" style="height: 286.341px;">
                                     <p class="selectRoom__diagram_floorNum"
                                    v-for="(deck, i) in decks" :key="('key_'+i)"
                                    :class="{ floorNum_active: deck == selectedDeck}"
                                    @click="changeDeck(deck)"
                                    >
                                        {{getDeckCN(deck)}}
                                    </p>
                                </div>
                                <div class="selectRoom__diagram_room">
                                    <p>请选择房间号</p>
                                    <div class="selectRoom__diagram_roomNum" style="height: 286.341px;">
                                        <p class="cabinBtn"
                                        v-for="(cabinNumber, j) in getCabinsByDeck(selectedDeck)" :key="('cabin_' + j)"
                                        :class=" { roomNum_active: cabinNumber == selectedCabinNumber}"
                                        @click="changeCabin(cabinNumber)"
                                        >
                                            {{cabinNumber}}
                                        </p>
                                    </div>
                                </div>
                                <div class="selectRoom__diagram_submit">
                                    <button type="button" class="selectRoom__diagram_btn" @click="onCabinConfirm()">确定</button>
                                </div>
                                <div class="selectRoom__diagram_desc">*该甲板图仅供参考，请以实际可选房间号及房间信息为准。</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import deckHelper from '@/utilities/deckHelper'
export default {
    name: 'ChangeStateroomPopup',
    props: {
        isShow: {
            type: Boolean
        },
        booking: {
            type: Object,
            default () {
                return {
                    "sessionToken": "",
                    "stateroomNumber": "",
                    "deckNumber": ""
                }
            }
        },
        cabins: {
            type: Array,
            default () {
                return []
            }
        },
        onChangeStateroomConfirm: {
            type: Function
        }
    },
    data () {
        return {
            selectedDeck: '',
            selectedCabinNumber: '',
            isShowModal: false
        }
    },
    mounted () {
        if (this.booking.stateroomNumber && this.booking.stateroomNumber.length > 0) {
            this.selectedCabinNumber = this.booking.stateroomNumber
        }

        if (this.booking.deckNumber && this.booking.deckNumber.length > 0) {
            this.selectedDeck = this.booking.deckNumber
        }
    },
    methods: {
        getDeckCN(deck) {
            return deckHelper.transferDeckCN(deck)
        },
        getCabinsByDeck (deck) {
            const deckNumber = deck + ''
            let items = this.cabins.filter(r=>r.deckNumber == deckNumber).map(r=>r.cabinNumber)
            if (this.bookingDeckNumber && this.bookingDeckNumber.length > 0
            && this.bookingStateroomNumber && this.bookingStateroomNumber.length > 0) {
                if (deckNumber == this.bookingDeckNumber && !items.some(r=>r == this.bookingStateroomNumber)) {
                    items.push(this.bookingStateroomNumber)
                }
            }

            return _.orderBy(items)
        },
        changeDeck (deck) {
            this.selectedDeck = deck + ''
        },
        changeCabin (cabinNumber) {
            this.selectedCabinNumber = cabinNumber
        },
        onCabinConfirm () {
            this.onChangeStateroomConfirm(this.selectedCabinNumber, this.selectedDeck)
        },
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        }
    },
    computed: {
        deckImage() {
            const imgUrl = process.env.VUE_APP_IMG_URL;
            const shipCode = this.booking.shipCode
            if (!shipCode || shipCode.length == 0 || !this.selectedDeck || this.selectedDeck.length == 0) {
                return ''
            }
            let image = `${imgUrl}/DeckImages/${shipCode}${this.selectedDeck}.jpg`
            // 2021SC, 2019QN特殊图片
            const sailDate = this.booking.sailDate
            const sailDateTime = new Date(sailDate)
            if (shipCode == 'SC') {
                image = `${imgUrl}/DeckImages/${shipCode}${this.selectedDeck}.jpg`
            } else if (shipCode == 'OV') {
                image = `${imgUrl}/DeckImages/2024/${shipCode}${this.selectedDeck}.jpg`
            } else if (shipCode == 'QN' && sailDateTime.getTime() >= new Date('2019-01-01').getTime()) {
                image = `${imgUrl}/DeckImages/${shipCode}2019${this.selectedDeck}.jpg`
            } else if (shipCode == 'NV') {
              image = `${imgUrl}/DeckImages/2025/${shipCode}${this.selectedDeck}.jpg`
            }
            return image
        },
        decks () {
            let decks = []
            this.cabins.forEach((cabin) => {
                const deckNumber = parseInt(cabin.deckNumber)
                if (!decks.some(r=>r==deckNumber)) {
                    decks.push(deckNumber)
                }
            })
            if (this.bookingDeckNumber && this.bookingDeckNumber.length > 0) {
                const bookingDeck = parseInt(this.bookingDeckNumber)
                if (!decks.some(r=>r==bookingDeck)) {
                    decks.push(bookingDeck)
                }
            }

            decks = _.orderBy(decks,null,'desc')
            return decks
        },
        bookingStateroomNumber () {
            return this.booking.stateroomNumber
        },
        bookingDeckNumber () {
            return this.booking.deckNumber
        }
    },
    watch: {
        booking(newOne) {
            this.selectedCabinNumber = newOne.stateroomNumber
            this.selectedDeck = newOne.deckNumber
        },
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }
    }
}
</script>
<style lang="less" scoped>
.modal-body {
    padding: 20px;
    margin-top: 20px;
}
.modal-dialog {
    top: 5%;

}

.modal {
    .common-modal-close {
        position: absolute;
        width: 28px;
        top: 3px;
        right: 5px;
        z-index: 2;
        cursor: pointer;
    }
}

.modal.active {
    display: block;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}

#selectRoomModal {
    overflow: scroll;
    .selectRoom__diagram_pic {
        clear: both;
        overflow-y: scroll;
        width: 100%;
        position: relative;
        z-index: 999;
        div {
            display: inline-block;
        }
        .selectRoom__diagram_picture {
            width: 58%;
            margin-left: 12%;
            margin-right: 8%;
        }
        .selectRoom__diagram_arrowPic {
            position: fixed;
            top: 50%;
        }
        .selectRoom__arrowPic__txt {
            position: absolute;
            top: 42%;
            left: -24px;
            width: 70px;
            p {
                color: #031257;
                font-size: 17px;
            }
        }
    }
    .selectRoom__diagram_floor {
        overflow-y: auto;
        .selectRoom__diagram_floorNum {
            width: 64%;
            text-align: center;
            line-height: 35px;
            background: #fff;
            color: #031257;
            border: 1px solid #031257;
            border-radius: 2px;
            cursor: pointer;
        }

    }
    .selectRoom__diagram_room {
        margin-top: 20px;
        .selectRoom__diagram_roomNum {
            clear: both;
            overflow-y: auto;
            p {
                width: 28%;
                text-align: center;
                line-height: 35px;
                border-radius: 2px;
                background: #fff;
                color: #031257;
                border: 1px solid #031257;
                float: left;
                margin-right: 4%;
                cursor: pointer;
            }
        }
    }
    .roomNum_active, .floorNum_active {
        background: #031257 !important;
        color: #fff !important;
    }
    .selectRoom__diagram_submit {
        margin-top: 28px;
        .selectRoom__diagram_btn {
            width: 90%;
            height: 36px;
            line-height: 36px;
            font-weight: bold;
            color: #031257;
            background: #fbc300;
            border-radius: 20px;
        }
    }
  .selectRoom__diagram_desc {
    width: 90%;
    margin-top: 10px;
    color: #999999;
  }
}
</style>
